module.exports = __webpack_public_path__ + "img/提现背景图2.2c54373b.png";